import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { tap, catchError, finalize, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of, fromEvent } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { projectConstants } from '../../../shared/constants/project-constants';
import { PaginationService } from 'src/app/services/pagination.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { AccountUserService } from 'src/app/services/account-user.service';
import { MatPaginator } from '@angular/material/paginator';
@Component({
  selector: 'app-account-user-list',
  templateUrl: './account-user-list.component.html',
  styleUrls: ['./account-user-list.component.css']
})
export class AccountUserListComponent implements OnInit, AfterViewInit {
  dataSource = new AccountUserDataSource(this.accountuserService);
  tableFilters = '';
  displayedColumns = ['id', 'account', 'firstName', 'lastName', 'primaryMobileNo', 'userType', 'status','type'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  selectedRowIndex = -1;
  showToolBar = false;
  collapsed;
  collapsedlcFilter;
  userCount: any;
  scConfig: any = {};
  userTypes: any = [];
  screenHeight;
  screenWidth;
  showsaleschannel;
  small_device_display = false;
  salesfilter;
  accountTypes: any = [];
  salesChannelfilter;
  consumerCount: number;
  user: any;
  type: any;
  pageSize: number;
  pageNo: number;
  pageIndex: number;
  sales_type_statuses = projectConstants.SALES_TYPE_STATUSES;
  page_Number: any;
  constructor(
    private pagination: PaginationService,
    private accountuserService: AccountUserService,
    private commonFilter: CommonfilterService,
    private route: ActivatedRoute,
    private router: Router,
    private commonfilterService: CommonfilterService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog) {
    this.commonfilterService.getConfigData()
      .subscribe(res => {
        this.scConfig = res;
        this.userTypes = this.scConfig.userType;
      });
    this.onResize();
  } 

  ngOnInit() {
    // this.activatedRoute.queryParams.subscribe(params => {
    //   this.page_Number = params.pageNumber;
    //   if (this.page_Number === undefined || this.page_Number === 'undefined') {
    //     this.page_Number = 0;
    //   }
    //   this.page_Number = this.page_Number * 10
    // });
    // this.dataSource.loadUser(this.tableFilters, 'false', this.page_Number, 10);
    this.dataSource.loadUser(this.tableFilters, 'false', 0, 100);
    this.getTotalCountByFilters(this.tableFilters);


  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  getTotalCountByFilters(filters) {
    this.accountuserService.getTotalFilterCount(filters)
      .subscribe(res => {
        this.userCount = res;
        // this.paginator.pageIndex = 0;
      });
  }
  ngAfterViewInit() {
    this.paginator.page
      .pipe(
        tap(() => this.loadUserPage())
      )
      .subscribe();

    fromEvent(this.go.nativeElement, 'click')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.tableFilters = this.commonFilter.createfilterParams('Accountuser');
          this.getTotalCountByFilters(this.tableFilters);
          this.paginator.pageIndex = 0;
          this.loadUserPage();

        })
      )
      .subscribe();
  }
  loadUserPage() {
    const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
  
    this.dataSource.loadUser(
  
      this.tableFilters,
      'false',
      count,
      this.paginator.pageSize);
  }
  onRowClicked(user) {
    this.selectedRowIndex = user.user.id;
    this.user = user;
    this.showToolBar = true;
  }
  // pageEvents(event: any) {
  //   this.pageIndex = event.pageIndex;
  // }
}
export class AccountUserDataSource implements DataSource<any> {

  constructor(private accountuserService: AccountUserService) {

  }
  public loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  private salesChannelSubject = new BehaviorSubject<any>([]);

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.salesChannelSubject.asObservable();
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.salesChannelSubject.complete();
    this.loadingSubject.complete();
  }
  loadUser(filter,
    sortDirection, tcount, pageSize) {
    this.loadingSubject.next(true);

    this.accountuserService.getAccountUsers(filter, sortDirection,
      tcount, pageSize).pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(
        salesChannels => {
          this.salesChannelSubject.next(salesChannels);
        }
      );
  }
}
